import { useAppSelector } from '../../lib/hooks';
import { defaultFilterOptions, setToolOpenStatus } from '../../lib/state/slices/ProjectStateSlice';
import { Box, Icon, StatusIndicator, StatusRoot } from '@chakra-ui/react';
import { Search, Folder } from 'react-feather';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Tooltip } from '../ui/tooltip';
import { deepSubsetEqual } from '@/lib/DeepCompare';
import { useSystemTheme } from '@/lib/ThemeSwitcher';

export default function PersistentBar() {
  const dispatch = useDispatch();
  const toolOpenStatus = useAppSelector((state) => state.viewReducer.toolOpenStatus);
  const [isFilterActive, setIsFilterActive] = useState(false); // Set this to true if any filter or search is active on the current page
  const filter = useAppSelector((state) => state.viewReducer.documents.filter);
  const location = useLocation();
  const searchQuery = useAppSelector((state) => state.viewReducer.documents.search.query);
  const { system } = useSystemTheme();

  
  useEffect(() => {
    setIsFilterActive(!deepSubsetEqual(defaultFilterOptions, filter));
  }, [JSON.stringify(filter)]);
  useEffect(() => {
    if (/saved_cases\/?$/.test(location.pathname)) {
      setIsFilterActive(!(searchQuery.FOLDER === ''));
    } else if (/(saved_cases\/.+$)|(graphs\/.+$)/.test(location.pathname)) {
      setIsFilterActive(!(searchQuery.DOCUMENT === ''));
    } else if (/graphs\/?$/.test(location.pathname)) {
      setIsFilterActive(!(searchQuery.GRAPH === ''));
    }
  }, [location.pathname, searchQuery, isFilterActive]);
  return (
    <Box
      height={'100%'}
      width="auto"
      p={2}
      display={'flex'}
      flexDirection={'column'}
      alignItems={'center'}
    >
      <Icon
        width={'40px'}
        height={'40px'}
        color="whiteIcon"
        background={toolOpenStatus.search ? 'logoPurple' : 'navButtonDefault'}
        _hover={{ bg: 'navButtonHover', cursor: 'pointer' }}
        _active={{ bg: 'navButtonActive' }}
        borderRadius={20}
        p={1.5}
        m={1}
        marginTop={5}
        cursor={'pointer'}
        onClick={() =>
          dispatch(
            setToolOpenStatus({ savedCases: false, aiChat: false, search: !toolOpenStatus.search }),
          )
        }
      >
        <StatusRoot position={'relative'}>
          {isFilterActive && (
            <Tooltip content="You have filters active which might limit the results you are seeing">
              <StatusIndicator
                style={{
                  position: 'absolute',
                  top: 1,
                  right: 1,
                  background: system.tokens.getVar('colors.accentBlue'),
                }}
              />
            </Tooltip>
          )}
          <Search />
        </StatusRoot>
      </Icon>
      <Icon
        as={Folder}
        width={'40px'}
        height={'40px'}
        color="whiteIcon"
        background={toolOpenStatus.savedCases ? 'logoPurple' : 'navButtonDefault'}
        _hover={{ bg: 'navButtonHover', cursor: 'pointer' }}
        _active={{ bg: 'navButtonActive' }}
        borderRadius={8}
        p={1.5}
        cursor={'pointer'}
        onClick={() =>
          dispatch(
            setToolOpenStatus({
              aiChat: false,
              search: false,
              savedCases: !toolOpenStatus.savedCases,
            }),
          )
        }
      />
      {/* <Box */}
      {/*   width={'40px'} */}
      {/*   height={'40px'} */}
      {/*   background={toolOpenStatus.aiChat ? 'logoPurple' : 'backgroundSecondary'} */}
      {/*   borderRadius={8} */}
      {/*   alignItems={'center'} */}
      {/*   display={'flex'} */}
      {/*   justifyContent={'center'} */}
      {/*   p={1.5} */}
      {/*   m={1} */}
      {/*   cursor={'pointer'} */}
      {/*   onClick={() => */}
      {/*     dispatch( */}
      {/*       setToolOpenStatus({ */}
      {/*         aiChat: !toolOpenStatus.aiChat, */}
      {/*         search: false, */}
      {/*         savedCases: false, */}
      {/*       }), */}
      {/*     ) */}
      {/*   } */}
      {/* > */}
      {/*   <AISparcles size={24} /> */}
      {/* </Box> */}
    </Box>
  );
}
